export default __webpack_public_path__ + "static/media/argon-react.6cafac31.png";